export function getMoveHistory(chess) {
  const moves = chess.moves({ verbose: true });
  return moves.map(move => ({
    piece: move.piece.toUpperCase() === move.piece ? move.piece : move.piece.toLowerCase(),
    from: move.from,
    to: move.to
  }));
}